export default class StringUtils {
  static pad(number: number, size: number): string {
    let result = String(number);
    while (result.length < (size || 2)) {
      result = "0" + result;
    }
    return result;
  }
}
